import * as angular from 'angular';

const fdAnbindungHtml = require('../../views/fd_anbindung.html');

'use strict';

angular.module('formApp').directive('fdAnbindung', function () {
  return {
    templateUrl: fdAnbindungHtml,
    scope: false,
    link: function (scope, element, attributes) {
      scope.anbindung = {
        outgoing: attributes.outgoing !== undefined && attributes.outgoing !== 'false',
        incoming: attributes.incoming !== undefined && attributes.incoming !== 'false'
      };
    },
    replace: true
  };
});
